import axios from 'axios';
import Cookies from 'js-cookie';

export const api = axios.create({
  baseURL: '/api',
  withCredentials: true,
});

// Instancia secundaria para llamadas a rutas fuera de /api
export const rawAxios = axios.create({
  baseURL: '/',
  withCredentials: true,
});

rawAxios.interceptors.request.use(config => {
  const token = Cookies.get('XSRF-TOKEN');
  if (token) {
    config.headers['X-XSRF-TOKEN'] = token;
  }
  return config;
});

// Cargar config mariadb si existe
const config = localStorage.getItem('mariadb_config');
if (config) {
  api.defaults.headers.common['X-MariaDB-Config'] = config;
}

export default api;
